// components/LoveNotes.js
import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

const loveNotes = [
  "Jeg elsker deg fordi du får meg alltid til å le og vi har det alltid kjempegøy sammen",
  "Jeg elsker deg fordi du alltid har gode påfunn og legger alltid opp til at vi skal finne på hyggelige ting sammen",
  "Jeg elsker deg fordi du har verdens fineste øyne og jeg er så utrolig glad for at jeg kan se på de så ofte som jeg kan",
  "Jeg elsker deg fordi du alltid legger opp til at jeg skal ha det bra",
  "Jeg elsker deg fordi du bryr deg om meg og alle rundt deg",
  "Jeg elsker deg fordi jeg alltid kan stole på deg og at jeg føler meg veldig trygg på deg",
  "Jeg elsker deg fordi du er utrolig fin naturlig. Hver gang jeg ser deg uten sminke tenker jeg alltid på hvor fin du ser naturlig ut",
  "Jeg elsker deg fordi du er smart på alle områder og jeg er veldig glad for å ha en kjæreste som jeg kan ha intellektuelle samtaler med",
  "Jeg elsker deg fordi du har et utrolig fint hår",
  "Jeg elsker deg fordi du aldri gir opp og alltid bygger forholdet vårt sterkere. Jeg er uendelig takknemlig for det",
  "Jeg elsker deg fordi jeg vet du kommer til å bli en utrolig god mor og jeg vil at du skal være moren til mine barn",
  "Jeg elsker deg fordi du er veldig god på å vise at du er glad i meg og jeg elsker alle de ulike måtene du viser det på",
  "Jeg elsker deg fordi du har veldig hyggelige og snille venner og jeg er veldig glad for at jeg får bli kjent med de",
  "Jeg elsker deg fordi du har en veldig fin klesstil og jeg elsker alle smykkene og klærne dine",
  "Jeg elsker deg fordi du alltid kommer løpende med samme entusiasme når jeg møter på deg. Det fins ikke en bedre følelse enn å åpne en dør når du kommer løpende og klemmer meg",
  "Jeg elsker deg fordi du har verdens fineste kropp og verdens peneste ansikt",
  "Jeg elsker deg fordi jeg føler at jeg kan snakke med deg om alt noe som er en stor trygghet",
  "Jeg elsker deg fordi du alltid ønsker og er med på å løse konflikter og at vi alltid klarer å løse de sammen. Jeg setter også stor pris på at du er raskt til å si unnskyld",
  "Jeg elsker deg fordi du alltid lukter utrolig godt",
  "Jeg elsker deg fordi du er veldig god på å kommunisere",
  "Jeg elsker deg fordi du er der for meg når jeg trenger det, både når det gjelder å høre på meg og å vise omsorg",
  "Jeg elsker deg fordi du har en veldig fin familie og jeg gleder meg til å bli kjent med resten av familien din",
  "Jeg elsker deg fordi du er verdens fineste på utsiden og på innsiden",
  "Jeg elsker deg fordi du er min kjæreste og bestevenn. Jeg er så utrolig takknemlig for at du er kjæresten min og all den tiden jeg får tilbringe med deg. D e dæ å mæ fer allti <3 "
];

const LoveNote = ({ text, index, visible }) => (
  <div 
    className={`w-full max-w-2xl mx-auto mb-8 transform transition-all duration-1000
      ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}
  >
    <div className="bg-white rounded-xl p-6 shadow-lg backdrop-blur-sm bg-opacity-95">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
            <Heart className="w-5 h-5 text-red-500" />
          </div>
        </div>
        <div className="flex-1">
          <div className="text-sm text-gray-500 mb-1">Grunn {index + 1}</div>
          <p className="text-gray-800 text-lg">{text}</p>
        </div>
      </div>
    </div>
  </div>
);

const LoveNotes = ({ show }) => {
  const [visibleNotes, setVisibleNotes] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      
      // Calculate how many notes should be visible based on scroll position
      const scrollProgress = scrollPosition / (docHeight - windowHeight);
      const notesToShow = Math.ceil(scrollProgress * loveNotes.length);
      
      setVisibleNotes(Array(notesToShow).fill(true));
    };

    if (show) {
      window.addEventListener('scroll', handleScroll);
      // Initialize with all notes hidden
      setVisibleNotes(Array(loveNotes.length).fill(false));
      // Trigger initial calculation
      handleScroll();
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, [show]);

  if (!show) return null;

  return (
    <div className="pt-[80vh] pb-20 px-4">
      {loveNotes.map((note, index) => (
        <LoveNote 
          key={index}
          text={note}
          index={index}
          visible={visibleNotes[index]}
        />
      ))}
    </div>
  );
};

export default LoveNotes;